import { Radio, Spin } from 'antd';
import { CustomModal } from './ScenarioColumnEditModal';
import { useContext, useEffect, useState } from 'react';
import { pricingSimulatorDataContext } from 'contexts/PricingSimulatorContext';
import { colorConstants } from 'config/colorConstants';
import { transformFilterObjectWithDimensionsInfo } from 'utils/getPricingSimulatorTableColumns';
import { UserContext } from 'contexts/ConfigContext';
import { getConfig, sendNotification } from 'utils/helperMethods';
import { PricingSimulatorNotificationMessages } from 'utils/Enums';
import { antIcon } from 'components/molecules/Filter/FilterApplyButton';
import { pricingSimulatorWrapperDataContext } from 'contexts/PricingSimulatorWrapperContext';

type PopupProps = {
    open: boolean;
    onCancel: (e: React.MouseEvent<HTMLElement, MouseEvent>) => void;
    onSubmitClick: (taskId: string, enablePolling: boolean) => void;
};

const ExportScenarioModal = ({ open, onCancel, onSubmitClick }: PopupProps) => {
    const { selectedScenarioInfo, applyFilterObject, selectedProjectInfo, showIsEditedRecords } =
        useContext(pricingSimulatorDataContext);
    const [tempRadioState, setTempRadioState] = useState<'current_view' | 'all_data'>('current_view');

    const {
        appConfig,
        exportSimulatorOptions: { exportScenarioLoading, exportSimulatorScenario },
    } = useContext(UserContext);
    const { dimensionConfigData } = useContext(pricingSimulatorWrapperDataContext);
    const scenarioFilterKeys = dimensionConfigData?.scenarioFilterKeys ?? [];

    const pricingSimulatorConfig = getConfig('pricingSimulator', appConfig);

    useEffect(() => {
        if (!open) {
            setTempRadioState('current_view');
        }
    }, [open]);

    return (
        <CustomModal
            width={400}
            cancelButtonProps={{ style: { borderRadius: 6 } }}
            onCancel={(e) => {
                onCancel(e);
            }}
            onOk={(e) => {
                if (exportScenarioLoading) return;
                const kpiIds: any[] = [];
                let isEdited = false;
                const tempApplyFilterObj: any = tempRadioState === 'all_data' ? {} : applyFilterObject;
                if (tempRadioState === 'current_view') {
                    //get all the kpi ids of all active lens
                    selectedScenarioInfo?.lenseConfig
                        ?.filter((lens) => {
                            return lens.isSelected;
                        })
                        .forEach((lens) => {
                            lens.attributes.map((kpi) => {
                                kpiIds.push(kpi.attributeId);
                            });
                        });
                    isEdited = showIsEditedRecords;
                } else {
                    scenarioFilterKeys.forEach((filter: any) => {
                        tempApplyFilterObj[filter.value] = {};
                    });
                }

                const filters = transformFilterObjectWithDimensionsInfo(tempApplyFilterObj, scenarioFilterKeys);

                const search = tempRadioState === 'all_data' ? '' : selectedScenarioInfo?.search || '';
                const kpisUnderActiveLense = selectedScenarioInfo?.activeLense?.activeLenseData?.attributes
                    ?.filter((item) => {
                        return item.isSelected;
                    })
                    .map((item) => item.attributeId);
                const selectedDimensionListValues =
                    selectedScenarioInfo?.dimAttributes?.map((item) => item?.value) || [];

                //will be true if list contains product, geo
                const isDropdownAtLowestLevel =
                    selectedDimensionListValues.includes(dimensionConfigData?.defaultDim1DropdownItem?.value ?? '') &&
                    selectedDimensionListValues.includes(dimensionConfigData?.defaultDim2DropdownItem?.value ?? '');

                let payload: any = {
                    is_edited: isEdited,
                    kpi_list: tempRadioState === 'current_view' ? kpisUnderActiveLense : kpiIds,
                    search_keyword: search,
                    filters: filters,
                    scenario_id: selectedScenarioInfo?.scenarioId,
                    scenario_name: selectedScenarioInfo?.scenarioName,
                    project_name: selectedProjectInfo?.projectName,
                    sort_by: selectedScenarioInfo?.sortObject?.sortBy ?? '',
                    sorting_order: selectedScenarioInfo?.sortObject?.sortingOrder ?? 'asc',
                    sort_type: selectedScenarioInfo?.sortObject?.sortType ?? 'actual',
                    is_lowest: Boolean(isDropdownAtLowestLevel),
                };
                if (tempRadioState === 'current_view')
                    payload = { ...payload, dimension_attributes: selectedDimensionListValues };
                else payload = { ...payload, all_export: true };
                sendNotification('info', PricingSimulatorNotificationMessages.SCENARIO_EXPORT_QUEUE, 5, 500);
                exportSimulatorScenario(payload, onSubmitClick);
                onCancel(e);
            }}
            title={`Export: ${selectedScenarioInfo?.scenarioName}`}
            centered
            open={open}
            okButtonProps={{ style: { borderRadius: 6 } }}
            okText={exportScenarioLoading ? <Spin indicator={antIcon} style={{ color: 'white' }} /> : 'Export'}
        >
            <div className="border border-backgroundGreyAlt6 rounded p-3">
                <p className="px-3 font-xs text-fontGreyAlt">Choose export option</p>
                <div className="p-3">
                    <Radio.Group
                        onChange={(e) => {
                            setTempRadioState(e.target.value);
                        }}
                        value={tempRadioState}
                    >
                        <Radio
                            disabled={false}
                            style={{ color: colorConstants.blackAlt1, width: 200, marginBottom: 4 }}
                            value={'current_view'}
                        >
                            <span className="font-xs">Export current view </span>
                        </Radio>
                        <Radio disabled={false} style={{ color: colorConstants.blackAlt1 }} value={'all_data'}>
                            <span className="font-xs">Export all data</span>
                        </Radio>
                    </Radio.Group>
                </div>
            </div>
        </CustomModal>
    );
};
export default ExportScenarioModal;
